import liveswitch from './libs/fm.liveswitch';
import LiveSwitchConnectionStats from './liveSwitchConnectionStats';
import LiveSwitchAudioAnalyser from './liveSwitchAudioAnalyser';
import LiveSwitchDeviceHelper from './liveSwitchDeviceHelper';
import AdiaLive5Error from "./adiaLive5Error";
import AdiaLive5P2PRecorder from "./adiaLive5P2PRecorder";
import AdiaLive5SignallingClient from "./adiaLive5SignallingClient";
import ResizeObserver from "resize-observer-polyfill";

export default class LiveSwitchWebRTCHandler{
    constructor(options){
        const _this = this;

        this.enableLogging = options.enableLogging;
        this.enableWebRtcLogging = options.enableWebRtcLogging;

        if(this.enableWebRtcLogging){
            liveswitch.Log.setProvider(new liveswitch.ConsoleLogProvider(liveswitch.LogLevel.Debug));
        }
        else{
            liveswitch.Log.setProvider(new liveswitch.ConsoleLogProvider(liveswitch.LogLevel.None));
        }

        if(this.enableLogging){
            console.log('%c' + 'Lib version: ', 'color:chocolate; font-weight:bold', liveswitch.Build.getVersion());
        }

        this.webRTCLayer = options.webRTCLayer;

        this.camSettings = {
            cam: 'Default',
            res: 'Default',
            mic: 'Default'
        };

        this.maxVideoBitrate = (options.maxVideoBitrate && options.maxVideoBitrate > 0) ? options.maxVideoBitrate : 0;

        if(options && options.camSettings){
            for(let prop in options.camSettings) {
                this.camSettings[prop] = options.camSettings[prop];
            }
        }

        // TODO Change meetingId to rather use channel (should be the same)
        this.meetingId = null;
        this.meetingInfo = null;
        this.meetingUserId = null;

		this.iceServers = null;
		this.iceGatherPolicy = null;

        this.devices = {
            audio: null,
            video: null
        }

        this.communicationMode = (options.communicationMode) ? options.communicationMode : 'both';

        this.failedCommModes = [];

        this.devicesLoadedPromise = null;
        //this.loadDeviceLists();

        this.localMedia = null;
        this.localMediaScreen = null;

        this.view = document.createElement('div');
        this.view.setAttribute('id', 'al5_videoContainer');

        this.client = null;
        this.channel = null;
        this.connected = 0;

        this.isUnregistering = false;
        this.reRegisterBackoff = 1000;
        this.maxRegisterBackoff = 16000;

        this.browser = this.getBrowserInfo();

        this.statsCollectors = {};

        this.connectionMode = options.connectionMode;

        this.activeConnections = {};    // To track a remote clients current active connection & ignore old dead connections

        this.recorder = null;

        if (this.connectionMode === 'liveSwitchSfu'){
            this.sfuUpstreamConnection = null;
            this.sfuUpstreamConnectionScreen = null;
            this.sfuDownstreamConnections = {};
        }
        else {
            this.p2pConnections = {};
        }

        this.audioAnalyser = null;

        this.audioLevelHandler = function(audioLevel){
            const userAudioLevel = {
                userId: (_this.client) ? _this.client.getUserId() : 'local',
                audioLevel: audioLevel,
            };

            _this.onAudioLevel(userAudioLevel);
        };

        this.settingsOptions = null;

        // Polyfill for scheiss IE
        if (!String.prototype.endsWith) {
            String.prototype.endsWith = function(search, this_len) {
                if (this_len === undefined || this_len > this.length) {
                    this_len = this.length;
                }
                return this.substring(this_len - search.length, this_len) === search;
            };
        }

        this.getConnectionForUser = function(userId){
            const connections = (this.connectionMode === 'liveSwitchSfu') ? this.sfuDownstreamConnections : this.p2pConnections;
            for (let connectionId in connections) {
                const connection = connections[connectionId];

                if(connection.getTag() === userId){
                    return connection;
                }
            }

            return null;
        };

        this.getRemoteMedia = function(connection){
            let remoteMedia = null;
            if(connection){
                if(this.connectionMode === 'adiaP2P'){
                    remoteMedia = connection.getRemoteMedia();
                }
                else if(connection.getInternalConnection()){
                    remoteMedia = connection.getInternalConnection().getRemoteMedia();
                }
            }

            return remoteMedia;
        }

        this.addRemoteStream = function(connection){
            return new Promise(function (resolve, reject) {
                const remoteMedia = _this.getRemoteMedia(connection)
                if(remoteMedia){
                    const stream = _this.getNativeStream(remoteMedia);
                    if(stream){
                        const objectStore = (connection.getTag().endsWith('_screenFromThem')) ? 'remoteScreenStream' : 'remoteStream';

                        const userId = connection.getTag().replace('_screenFromThem', '');
                        const meetingUserId = connection.getDynamicValue('meetingUserId');

                        const event = (connection.getTag().endsWith('_screenFromThem')) ? 'screenshareStarted' : 'addedRemoteStream';

                        _this.recorder.addToEventLog({userId: userId, meetingUserId: meetingUserId, event: event});

                        _this.recorder.addStream(connection.getTag(), objectStore, meetingUserId, stream)
                        .then(function (result) {
                            resolve(result);
                        })
                        .catch(function(ex){
                            reject(ex);
                        })
                    }
                    else{
                        _this.onNotification(16, 'No stream found, nothing to record');

                        resolve('No stream found to record');
                    }
                }
                else{
                    _this.onNotification(16, 'No remote media found, nothing to record');

                    resolve('No remote media found, nothing to record');
                }
            })
        };

        this.getNativeStream = function(media){
        	const nativeVideoStream = media._getInternal()._getVideoMediaStream();
			const nativeAudioStream = media._getInternal()._getAudioMediaStream();

			let nativeStream = null;
        	if(nativeVideoStream && nativeVideoStream.active){
				nativeStream = nativeVideoStream
            }
        	else if(nativeAudioStream && nativeAudioStream.active){
				nativeStream = nativeAudioStream;
			}

        	return nativeStream;
		};

        // Add missing functionality to old connection object
        this.upgradeConnectionObject = function(connection){
			if(connection instanceof liveswitch.Connection){
				connection.tag = null;
				connection.setTag = function(tag){this.tag = tag};
				connection.getTag = function(){return this.tag};

				connection.remoteVideoMuted = false;
				connection.setRemoteVideoMuted = function(remoteVideoMuted){this.remoteVideoMuted = remoteVideoMuted};
				connection.getRemoteVideoMuted = function(){return this.remoteVideoMuted};
        }
		};

        this.sendRoomNotification = function(event){
        	if(this.signallingClient){
				this.signallingClient.sendRoomNotification({userId: this.client.getUserId(), meetingUserId: this.client.getUserAlias(), event: event});
			}
		}

		//console.log('options:', options)

        // Simulcast
        this.useSimulcast = options.useSimulcast;
        this.adaptiveQuality = options.useSimulcast && options.adaptiveQuality; // Off if simulcast is off

        if(this.enableLogging){
            console.log('%c' + 'Simulcast:', 'color:cornflowerblue; font-weight:bold', (this.useSimulcast) ? 'on' : 'off');
            console.log('%c' + 'Adaptive Quality:', 'color:cornflowerblue; font-weight:bold', (this.adaptiveQuality) ? 'on' : 'off');
        }

        /*
        // Simulcast custom presets, no longer needed
        this.qualityPresets = {
            high: {bitrate:1024, frameRate: 30, scale: 1},
            med: {bitrate:512, frameRate: 15, scale: 0.5},
            low: {bitrate:256, frameRate: 7.5, scale: 0.25}
        }
         */

        //console.log('this.useSimulcast', this.useSimulcast);

        this.adaptiveQualityObservers = {};
        this.addAdaptiveQuality = function(userId, view){
            if(this.enableLogging){
                console.log('%c' + 'Starting adaptive quality for:', 'color:cornflowerblue; font-weight:bold', userId);
            }

            const _this = this;

            const observer = new ResizeObserver(function(entries){
                for (let entry of entries) {
                    let width = 0;
                    if(entry.contentBoxSize) {
                        width = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0].inlineSize : entry.contentBoxSize.inlineSize
                    }
                    else {
                        width = entry.contentRect.width;
                    }

                    const targetQuality = (width <= 400) ? 'low' : 'high';
                    _this.setRemoteQuality(targetQuality, userId);

                    if(_this.enableLogging){
                        console.log('%c' + 'Switched video quality:', 'color:cornflowerblue; font-weight:bold', userId, '->', targetQuality);
                    }
                }
            });

            observer.observe(view);

            this.adaptiveQualityObservers[userId] = observer;
        };

        this.removeAdaptiveQuality = function(userId){
            if(this.enableLogging){
                console.log('%c' + 'Stopping adaptive quality for:', 'color:cornflowerblue; font-weight:bold', userId);
            }

            const observer = this.adaptiveQualityObservers[userId];

            if(observer){
                observer.disconnect();

                delete this.adaptiveQualityObservers[userId];
            }
        };

        this.startViewAppendObserver = function(){
            this.mutationObserver = new MutationObserver(function(mutationsList){
                function getVideoContainer(node){
                    if(node.classList.contains('fm-video')){
                        return node;
                    }
                    else{
                        return node.querySelector('.fm-video');
                    }
                }

                function getRemoteUserIdFromClassList(classList){
                    for (let i = 0; i < classList.length; i++) {
                        const currentClass = classList[i];

                        if(currentClass.startsWith('remote_')){
                            return currentClass.replace('remote_', '');
                        }
                    }

                    return null;
                }

                mutationsList.forEach(function (mutation) {
                    if (mutation.type == 'childList') {
                        mutation.addedNodes.forEach(function (node) {
                            if(node.nodeType !== Node.TEXT_NODE){
                                const videoContainer =  getVideoContainer(node);
                                if(videoContainer){
                                    const userId = getRemoteUserIdFromClassList(videoContainer.classList);

                                    if(userId){
                                        const width = videoContainer.offsetWidth;
                                        const targetQuality = (width <= 400) ? 'low' : 'high';
                                        _this.setRemoteQuality(targetQuality, userId);
                                    }
                                }
                            }
                        });
                    }
                });
            });

            this.mutationObserver.observe(document.body, {childList: true, subtree: true});
        };

        this.stopViewAppendObserver = function(){
            if(this.mutationObserver){
                this.mutationObserver.disconnect();
                this.mutationObserver = null;
            }
        };
    }

    getName(){return 'LiveSwitchWebRTCHandler'}

    getUserId(){
        if(this.client){
            return this.client.getUserId()
        }
        else{
            return null
        }
    }

    getIsConnected(){
        return !!this.channel;
    }

    getBrowserInfo(){
        const parser = require('ua-parser-js');
        const browserInfo = new parser();

        return browserInfo.getBrowser();
    }

    getTime(){
        const timestamp = new Date();
        const fullTime = timestamp.toTimeString();
        const timeParts = fullTime.split(' ');

        return timeParts[0];
    }

    getNumConnections(){
        if(this.connectionMode === 'liveSwitchSfu'){
            return Object.keys(this.sfuDownstreamConnections).length;
        }
        else{
            return Object.keys(this.p2pConnections).length;
        }
    }

    loadDeviceLists(){
        const _this = this;

        this.devicesLoadedPromise = LiveSwitchDeviceHelper.getDevices(this.communicationMode)
        .then(function(devices){
            _this.devices = devices;

            if(_this.communicationMode === 'none'){
                return devices;
            }

            if(_this.communicationMode === 'video' || _this.communicationMode === 'both'){
                const camDevice = _this.getDevice('video', _this.camSettings.cam);
                if(camDevice){
                    _this.camSettings.camDevice = camDevice;
                    _this.camSettings.cam = camDevice._name;
                }
            }

            if(_this.communicationMode === 'audio' || _this.communicationMode === 'both'){
                const micDevice = _this.getDevice('audio', _this.camSettings.mic);
                if(micDevice){
                    _this.camSettings.micDevice = micDevice;
                    _this.camSettings.mic = micDevice._name;
                }
            }

            return devices
        })
        .catch(function(error){
            throw(new AdiaLive5Error(13, error));
        });
    }

    getDeviceLists(communicationMode){
        const commMode = (communicationMode) ? communicationMode : this.communicationMode;
        return LiveSwitchDeviceHelper.getDeviceLists(commMode)
        .catch(function(error){
            throw(new AdiaLive5Error(13, error));
        });
    }

    getDevice(deviceType, deviceName) {
        if (!deviceName || deviceName.toLowerCase() === 'default' || (deviceType !== 'audio' && deviceType !== 'video')){
            return null
        }

        const deviceList = (deviceType === 'audio') ? this.devices.audio : this.devices.video;

        if(deviceList){
            const targetDeviceName = deviceName.toLowerCase();
            for (let i = 0; i < deviceList.length; i++) {
                const sourceDeviceName = deviceList[i]._name.toLowerCase();

                if (sourceDeviceName.indexOf(targetDeviceName) > -1) {
                    return deviceList[i];
                }
            }
        }

        return null;
    }

    setDevice(deviceType, deviceName){
        const _this = this;

        if((deviceType !== 'audio' && deviceType !== 'video') || typeof deviceName !== 'string'){
            return Promise.reject('Invalid parameter');
        }

        if(deviceType === 'audio'){
            this.camSettings.mic = deviceName;
            delete this.camSettings.micDevice;
        }
        else if(deviceType === 'video'){
            this.camSettings.cam = deviceName;
            delete this.camSettings.camDevice;
        }

        if(!this.localMedia){
            return Promise.resolve(LiveSwitchDeviceHelper.getCurrentSettings(this.localMedia));
        }

        // Local media running
        return new Promise(function (resolve, reject){
            if(deviceName.toLowerCase() === 'default'){
                if(_this.getIsConnected()){
                    if(_this.connectionMode === 'liveSwitchSfu' && _this.sfuUpstreamConnection){
                        _this.sfuUpstreamConnection.close();
                    }
                    else if(_this.connectionMode === 'liveSwitchPeer' || _this.connectionMode === 'adiaP2P'){
                        _this.stopPeer2PeerConnections('device');
                    }
                }

                _this.restartLocalMedia()
                .then(function(){
                    if((_this.communicationMode === 'audio' || _this.communicationMode === 'both') && _this.settingsOptions && _this.settingsOptions.onAudioLevel){
                        _this.localMedia.addOnAudioLevel(_this.settingsOptions.onAudioLevel);
                    }

                    if(_this.getIsConnected()){
                        if(_this.connectionMode === 'liveSwitchSfu'){
                            _this.openSfuUpstreamConnection('device');
                        }
                        else if(_this.connectionMode === 'liveSwitchPeer' || _this.connectionMode === 'adiaP2P'){
                            _this.startPeer2PeerConnections('device')
                        }
                    }

					if(_this.recorder){
						const event = (deviceType === 'audio') ? 'changedAudioDevice' : 'changedVideoDevice'
						_this.recorder.addToEventLog({userId: _this.client.getUserId(), meetingUserId: _this.client.getUserAlias(), event: event});

						_this.stopRecording();
					}

                    resolve(LiveSwitchDeviceHelper.getCurrentSettings(_this.localMedia))
                })
                .catch(function(error){
                    reject(error);
                });
            }
            else{
                _this.loadDeviceLists();

                _this.devicesLoadedPromise
                .then(function(){
                    if(deviceType === 'audio'){
                        if(!(typeof _this.camSettings.micDevice === 'object')){
                            reject(new AdiaLive5Error(16, {name: 'NotFoundError'}));
                        }
                        else{
                            _this.localMedia.changeAudioSourceInput(_this.camSettings.micDevice)
                            .then(function(){
								if(_this.recorder){
									_this.recorder.addToEventLog({userId: _this.client.getUserId(), meetingUserId: _this.client.getUserAlias(), event: 'changedAudioDevice'});

									// Stream needs to be added again, media recorder API doesn't support track change
									const stream = _this.getNativeStream(_this.localMedia);
									_this.recorder.addStream('local', 'localStream', _this.meetingUserId, stream)
									.then(function (result) {
                                        resolve(LiveSwitchDeviceHelper.getCurrentSettings(_this.localMedia));
                                    })
									.catch(function(exception){
										reject(new AdiaLive5Error(62, exception));
									})
								}
								else{
									resolve(LiveSwitchDeviceHelper.getCurrentSettings(_this.localMedia));
								}
                            })
                            .fail(function(error){
                                reject(new AdiaLive5Error(16, error));
                            });
                        }
                    }
                    else if(deviceType === 'video'){
                        if(!(typeof _this.camSettings.camDevice === 'object')){
                            reject(new AdiaLive5Error(17, {name: 'NotFoundError'}));
                        }
                        else{
                            _this.localMedia.changeVideoSourceInput(_this.camSettings.camDevice)
                            .then(function(){
								if(_this.recorder){
									_this.recorder.addToEventLog({userId: _this.client.getUserId(), meetingUserId: _this.client.getUserAlias(), event: 'changedVideoDevice'});

									// Stream needs to be added again, media recorder API doesn't support track change
									const stream = _this.getNativeStream(_this.localMedia);
									_this.recorder.addStream('local', 'localStream', _this.meetingUserId, stream)
									.then(function (result) {
                                        resolve(LiveSwitchDeviceHelper.getCurrentSettings(_this.localMedia));
                                    })
									.catch(function(error){
                                        reject(new AdiaLive5Error(62, error));
									})
								}
								else{
									resolve(LiveSwitchDeviceHelper.getCurrentSettings(_this.localMedia));
								}
                            })
                            .fail(function(error){
                                reject(new AdiaLive5Error(17, error));
                            });
                        }
                    }
                })
                .catch(function(error){
                    reject(error);
                });
            }
        })
    }

    setResolution(resolution){
        const _this = this;

        if(this.camSettings && this.camSettings.res === resolution){
            return Promise.resolve(LiveSwitchDeviceHelper.getCurrentSettings(_this.localMedia));
        }

        this.camSettings.res = resolution;
        const isAudioMuted = this.localMedia.getAudioMuted();

        if(this.getIsConnected()){
            if(this.connectionMode === 'liveSwitchSfu' && this.sfuUpstreamConnection){
                this.sfuUpstreamConnection.close();
            }
            else if(this.connectionMode === 'liveSwitchPeer' || this.connectionMode === 'adiaP2P'){
                this.stopPeer2PeerConnections('device');
            }
        }

        return this.restartLocalMedia()
        .then(function(){
            if((_this.communicationMode === 'audio' || _this.communicationMode === 'both') && _this.settingsOptions && _this.settingsOptions.onAudioLevel){
                _this.localMedia.addOnAudioLevel(_this.settingsOptions.onAudioLevel);
            }

            _this.localMedia.setAudioMuted(isAudioMuted);

            if(_this.getIsConnected()){
                if(_this.connectionMode === 'liveSwitchSfu'){
                    _this.openSfuUpstreamConnection('device');
                }
                else if(_this.connectionMode === 'liveSwitchPeer' || _this.connectionMode === 'adiaP2P'){
                    _this.startPeer2PeerConnections('device');
                }
            }

            return LiveSwitchDeviceHelper.getCurrentSettings(_this.localMedia);
        });
    }

    setCommunicationMode(communicationMode, force){
        const _this = this;

        if(communicationMode !== 'none' && communicationMode !== 'audio' && communicationMode !== 'video' && communicationMode !== 'both'){
            return Promise.reject('Invalid mode');
        }

        // todo: [MB] return resolved promise if communication mode will not change
        if (!force && _this.communicationMode === communicationMode){
            return Promise.resolve(_this.getSettingsComponents());
        }

        return new Promise(function (resolve, reject) {
            const previousCommMode = _this.communicationMode;

            if(_this.getIsConnected()){
                if(_this.connectionMode === 'liveSwitchSfu' && _this.sfuUpstreamConnection){
                    _this.sfuUpstreamConnection.close();
                }
                else if(_this.connectionMode === 'liveSwitchPeer' || _this.connectionMode === 'adiaP2P'){
                    _this.stopPeer2PeerConnections('device');
                }
            }

            // This resolves if no media or already stopped
            _this.stopLocalMedia()
            .then(function(){
                _this.communicationMode = communicationMode;

                _this.loadDeviceLists();

                _this.devicesLoadedPromise
                .then(function(){
                    if(_this.communicationMode !== 'none') {
                        _this.startLocalMedia()
                        .then(function(){
                            if((_this.communicationMode === 'audio' || _this.communicationMode === 'both') && _this.settingsOptions && _this.settingsOptions.onAudioLevel){
                                _this.localMedia.addOnAudioLevel(_this.settingsOptions.onAudioLevel);
                            }

                            if(_this.getIsConnected()){
                                if(_this.connectionMode === 'liveSwitchSfu'){
                                    _this.openSfuUpstreamConnection('device');
                                }
                                else if(_this.connectionMode === 'liveSwitchPeer' || _this.connectionMode === 'adiaP2P'){
                                    _this.startPeer2PeerConnections('device')
                                }
                            }

                            resolve(_this.getSettingsComponents());
                        })
                        .catch(function(error){
                            // Note which modes have been tried and don't try rollback to them (prevent infinite loop)
                            _this.failedCommModes.push(communicationMode)

                            const rollbackCommMode = (!_this.failedCommModes.includes(previousCommMode)) ? previousCommMode  : 'none';

                            // try to switch to previousCommMode
                            _this.setCommunicationMode(rollbackCommMode)
                            .then(function(){
                                _this.failedCommModes = [];
                                reject(error);
                            })
                            .catch(function(){
                                if(rollbackCommMode === 'none'){
                                    _this.failedCommModes = [];
                                }
                                _this.communicationMode = 'none';
                                reject(error);
                            });
                        });
                    }
                    else{
                        // p2p needs to build receive only connections here if connected
                        if(_this.getIsConnected() && _this.connectionMode === 'liveSwitchPeer' || _this.connectionMode === 'adiaP2P'){
                            _this.startPeer2PeerConnections('device');
                        }

                        resolve(_this.getSettingsComponents());
                    }
                })
                .catch(function(error){
                    // Note which modes have been tried and don't try rollback to them (prevent infinite loop)
                    _this.failedCommModes.push(communicationMode)

                    const rollbackCommMode = (!_this.failedCommModes.includes(previousCommMode)) ? previousCommMode  : 'none';

                    // try to switch to previousCommMode
                    _this.setCommunicationMode(rollbackCommMode)
                    .then(function(){
                        _this.failedCommModes = [];
                        reject(error);
                    })
                    .catch(function(){
                        if(rollbackCommMode === 'none'){
                            _this.failedCommModes = [];
                        }
                        _this.communicationMode = 'none';
                        reject(error);
                    });
                });
            })
            .catch(function(error){
                reject(error);
            });
        })

    }

    getCurrentSettings(){
        return {
            currentSettings: LiveSwitchDeviceHelper.getCurrentSettings(this.localMedia),
            communicationMode: this.communicationMode
        }
    }

    applySettings(settings){
        const _this = this;

        return new Promise(function (resolve, reject) {
            const previousSettings = _this.getCurrentSettings();

            _this.camSettings = settings.camSettings;
            _this.setCommunicationMode(settings.communicationMode, true)
            .then(function(result){
                resolve(result)
            })
            .catch(function(error){
                // Rollback to previous settings
                _this.camSettings = previousSettings.camSettings;
                _this.setCommunicationMode(previousSettings.communicationMode)
                .then(function(){
                    reject(error)
                })
                .catch(function(){
                    reject(error)
                })
            })
        })
    }

    getUserView(){
        return {
            userId: this.getUserId(),
            view: this.view,
            type: 'local',
            currentSettings: LiveSwitchDeviceHelper.getCurrentSettings(this.localMedia),
            communicationMode: this.communicationMode
        }
    }

    muteAudio(shouldMute){
        if(this.localMedia){
            this.localMedia.setAudioMuted(shouldMute);

            if(this.recorder){
				const event = (shouldMute) ? 'audioMuted' : 'audioUnmuted';
				this.recorder.addToEventLog({userId: this.client.getUserId(), meetingUserId: this.client.getUserAlias(), event: event});
            }
    }
    }

    muteVideo(shouldMute){
        if(this.localMedia){
            this.localMedia.setVideoMuted(shouldMute);

			const event = (shouldMute) ? 'videoMuted' : 'videoUnmuted';
			this.sendRoomNotification(event);

			if(this.recorder){
				this.recorder.addToEventLog({userId: this.client.getUserId(), meetingUserId: this.client.getUserAlias(), event: event});
			}
		}
    }

    muteRemoteAudio(shouldMute, userId){
        const connection = this.getConnectionForUser(userId);
        if(connection){
            //connection.setRemoteAudioMuted(shouldMute);         // On connection

            const remoteMedia = this.getRemoteMedia(connection);
            if(remoteMedia){
                remoteMedia.setAudioMuted(shouldMute);              // On remote media *works!*
            }
        }
    }

    muteRemoteVideo(shouldMute, userId){
        const connection = this.getConnectionForUser(userId);
        if(connection){
            //connection.setRemoteVideoMuted(shouldMute);

            const remoteMedia = this.getRemoteMedia(connection);
            if(remoteMedia){
                remoteMedia.setVideoMuted(shouldMute);
            }
        }
    }

    isDeviceMuted(deviceType){
        if(this.localMedia){
            if(deviceType === 'audio'){
                return this.localMedia.getAudioMuted();
            }
            else{
                return this.localMedia.getVideoMuted();
            }
        }
    }

    join(options, meetingInfo){
        const _this = this;

        return new Promise(function(resolve, reject){
            _this.meetingId = meetingInfo._id;
            _this.meetingInfo = meetingInfo;
            _this.meetingUserId = options.clientMetadata._id;

			if(options.iceServerAddress){
				const relayUsername = (options.relayUsername) ? options.relayUsername : 'test';
				const relayPassword = (options.relayPassword) ? options.relayPassword : 'pa55w0rd!';

				_this.iceServers = [
					new liveswitch.IceServer('stun:' + options.iceServerAddress + ':3478'),
					new liveswitch.IceServer('turn:' + options.iceServerAddress + ':80', relayUsername, relayPassword),
					new liveswitch.IceServer('turn:' + options.iceServerAddress + ':3478', relayUsername, relayPassword),
					new liveswitch.IceServer('turns:' + options.iceServerAddress + ':443', relayUsername, relayPassword),
					new liveswitch.IceServer('turns:' + options.iceServerAddress + ':5349', relayUsername, relayPassword),
				]

				_this.iceGatherPolicy = (options.forceRelaying) ? liveswitch.IceGatherPolicy.Relay : liveswitch.IceGatherPolicy.All;
			}
			else{
				_this.iceServers = null;
				_this.iceGatherPolicy = null;
			}

            _this.startLocalMedia()
            .then(function(){
                _this.isUnregistering = false;

                _this.register(options)
                .then(function(channels){
                    clearTimeout(_this.loginTimeout);

                    _this.audioAnalyser = new LiveSwitchAudioAnalyser({webRTCHandler: _this});
                    if(_this.communicationMode === 'audio' || _this.communicationMode === 'both'){
                        _this.audioAnalyser.userJoined(_this.client.getUserId());
                    }

                    resolve(_this.getUserView());
                })
                .catch(function(error){
                    clearTimeout(_this.loginTimeout);

                    reject(new AdiaLive5Error(21, error));
                });

                _this.loginTimeout = setTimeout(function(){
                    reject(new AdiaLive5Error(21,{name: 'timeout'}));
                }, 30000)
            })
            .catch(function(error){
                //reject(new AdiaLive5Error(11, error));
                reject(new AdiaLive5Error(AdiaLive5Error.LocalMediaStart, error));
            });
        });
    }

    leave(){
        const _this = this;

        return new Promise(function (resolve, reject) {
            if(_this.recorder){
				_this.recorder.addToEventLog({userId: _this.client.getUserId(), meetingUserId: _this.client.getUserAlias(), event: 'userLeft'});

                _this.stopRecording();
            }

            if(_this.localMediaScreen){
                _this.stopScreenshare();
                _this.onNotification(11, 'Screenshare stopped');
            }

            _this.meetingId = null;
            _this.meetingInfo = null;

            // Unregister will close all connections
            _this.unregister()
            .then(function(results){
                _this.audioAnalyser = null;

                _this.stopLocalMedia()
                .then(function(results){
                    resolve('Successfully left');
                })
                .catch(function(error){
                    reject(error);
                });
            })
            .catch(function(error){
                reject(new AdiaLive5Error(25, error));
            })
        });
    }

    startLocalMedia(){
        const _this = this;

        if(this.localMedia){
            return Promise.resolve(this.getUserView());
        }

        if(!_this.devicesLoadedPromise){
            _this.loadDeviceLists();
        }

        return new Promise(function(resolve, reject){
            _this.devicesLoadedPromise
            .then(function(){
                const needsAudio = (_this.communicationMode === 'audio' || _this.communicationMode === 'both');

                let needsVideo = false;
                if(_this.communicationMode === 'video' || _this.communicationMode === 'both'){
                    if(_this.camSettings.res && _this.camSettings.res !== 'default'){
                        const resolutionParts = _this.camSettings.res.split('x');
                        needsVideo = {
                            width: {ideal: resolutionParts[0]},
                            height: {ideal: resolutionParts[1]},
                        }
                    }
                    else{
                        needsVideo = true;
                    }
                }

                _this.localMedia = new liveswitch.LocalMedia(needsAudio, needsVideo);

                if(needsAudio && _this.camSettings.micDevice){
                    _this.localMedia.setAudioSourceInput(_this.camSettings.micDevice);
                }
                if(!!needsVideo && _this.camSettings.camDevice){
                    _this.localMedia.setVideoSourceInput(_this.camSettings.camDevice);
                }

                // Simulcast
                if(!!needsVideo && _this.useSimulcast){
                    _this.localMedia.setVideoSimulcastEncodingCount(3);
                    //console.log('%c' + 'Set video encodings for simulcast:', 'color:#F333FF;font-weight:bold;', videoEncodings);
                }

                _this.localMedia.start()
                .then(function(){
                    const videoEncodings = _this.localMedia.getVideoEncodings();

                    if(videoEncodings && videoEncodings.length > 2){
                        // Setup must be done here since these encodings don't exist before start
                        const resolution = LiveSwitchDeviceHelper.getVideoResolution(_this.localMedia);
                        const resolutionParts = resolution.split('x');
                        const width = parseInt(resolutionParts[0]);

                        const scale = 480 / width;
                        //const bitrate = 270 * 480 * 30 *0.05
                        const bitrate = 195;

                        videoEncodings[2].setScale(scale);
                        videoEncodings[2].setBitrate(bitrate);
                        _this.localMedia.setVideoEncodings(videoEncodings);
                    }

                    if(_this.communicationMode === 'audio' || _this.communicationMode === 'both'){
                        _this.localMedia.addOnAudioLevel(_this.audioLevelHandler);
                    }

                    if(_this.recorder){
						const stream = _this.getNativeStream(_this.localMedia);
                        _this.recorder.addStream('local', 'localStream', _this.meetingUserId, stream)
						.then(function (result) {
                            if(_this.useSimulcast){
                                _this.startViewAppendObserver();
                            }

                            const lmView = _this.localMedia.getView();
                            if(lmView){
                                _this.view.appendChild(lmView);
                            }

                            resolve(_this.getUserView());
						})
						.catch(function(error){
							reject(new AdiaLive5Error(62));
						})
                    }
                    else{
                        if(_this.useSimulcast){
                            _this.startViewAppendObserver();
                        }

                        const lmView = _this.localMedia.getView();
                        if(lmView){
                            _this.view.appendChild(lmView);
                        }

                        resolve(_this.getUserView());
					}
                })
                .fail(function(error){
                    _this.localMedia = null;

                    reject(new AdiaLive5Error(AdiaLive5Error.LocalMediaStart, error));
                })
            })
            .catch(function(error){
                reject(error)
            })
        });
    }

    stopLocalMedia(){
        const _this = this;

        if(!this.localMedia){
            return Promise.resolve('Local media not started')
        }

        return new Promise(function (resolve, reject) {
			if(_this.recorder){
				_this.recorder.removeStream('local');
			}

            _this.localMedia.stop()
            .then(function(result){
                //_this.localMedia.getViewSink().destroy();   // Fix for FM bug

                _this.stopViewAppendObserver();

                while (_this.view.firstChild) {
                    _this.view.removeChild(_this.view.firstChild);
                }

                if(_this.communicationMode !== 'video'){
                    _this.localMedia.removeOnAudioLevel(_this.audioLevelHandler);
                }

                _this.localMedia.destroy();
                _this.localMedia = null;

                resolve(result);
            })
            .fail(function(error){
                reject(new AdiaLive5Error(14, error));
            })
        })
    }

    restartLocalMedia(){
        const _this = this;

        return new Promise(function(resolve, reject){
            _this.stopLocalMedia()
            .then(function(){
                _this.startLocalMedia()
                .then(function(){
                    resolve()
                })
                .catch(function(error){
                    reject(error)
                })
            })
            .catch(function(error){
                reject(error)
            })
        })
    }

    register(options){
        const _this = this;

        return new Promise(function(resolve, reject){
            _this.devicesLoadedPromise
            .then(function(){
                if(_this.connectionMode === 'adiaP2P'){
                    // Create client like FM for compatibility
                    _this.client = {
                        userId: options.userId,
						userAlias: _this.meetingUserId,
                        getUserId: function(){return this.userId},
                        getUserAlias: function(){return this.userAlias}
                    };

                    _this.signallingClient = new AdiaLive5SignallingClient({url: options.url, enableLogging: _this.enableLogging});
                    _this.signallingClient.onSignalling = function(message){
                        let connectionTag = '';
						if(message.connectionType === 'main'){
							connectionTag = message.senderInfo.userId;
						}
						else{
							const screenFrom = message.connectionType.replace('screenFrom_', '');

							if(screenFrom === _this.client.getUserId()){
								connectionTag = message.senderInfo.userId + '_screenFromMe';
							}
							else{
								connectionTag = message.senderInfo.userId + '_screenFromThem';
							}
						}

                        let connection = null;
                        if(!_this.activeConnections.hasOwnProperty(connectionTag)){
                            connection = _this.openP2PAnswerConnection(message);
                        }
                        else{
                            const connectionId = _this.activeConnections[connectionTag];
                            connection = _this.p2pConnections[connectionId];
                        }

                        if(message.type === 'offeranswer'){
                            if(_this.enableLogging){
                                console.log('%c' + 'Received offeranswer from:', 'color:palevioletred; font-weight:bold', message.senderInfo.userId);
                            }

                            const sessionDescription = liveswitch.SessionDescription.fromJson(message.dataJSON);

                            if(sessionDescription.getIsOffer()){
                                connection.setRemoteDescription(sessionDescription)
                                .then(function(){
                                    connection.createAnswer()
                                    .then(function(answer){
                                        connection.setLocalDescription(answer)
                                        .then(function(answer){
                                            const msg = {
                                                senderInfo: {userId: _this.client.getUserId(), userAlias: _this.meetingUserId},
                                                receiverId: message.senderInfo.userId,
                                                connectionType: message.connectionType,
                                                type: 'offeranswer',
                                                dataJSON: answer.toJson()
                                            };

                                            _this.signallingClient.send(msg);
                                        })
                                        .fail(function(error){
                                            console.error('Error setting local description:', error)
                                        })
                                    })
                                })
                                .fail(function(error){
                                    console.error('Error setting remote description:', error)
                                })
                            }
                            else{
                            	// Is answer, save peer's meetingUserId
								connection.setDynamicValue('meetingUserId', message.senderInfo.userAlias);
                                connection.setRemoteDescription(sessionDescription);
                            }
                        }
                        else if(message.type === 'candidate'){
                            if(_this.enableLogging){
                                console.log('%c' + 'Received candidate from:', 'color:palevioletred; font-weight:bold', message.senderInfo.userId);
                            }

                            const candidate = liveswitch.Candidate.fromJson(message.dataJSON);

                            connection.addRemoteCandidate(candidate);
                        }
                    };

                    _this.signallingClient.onRoomNotification = function(roomNotification){
                        if(roomNotification.event === 'screenshareStopped' || roomNotification.event === 'deviceStopped'){
                        	// Kill stopped connection
							const connectionTag = (roomNotification.event === 'deviceStopped') ? roomNotification.userId : roomNotification.userId + '_screenFromThem';
							const connectionId = _this.activeConnections[connectionTag];

							if(connectionId && _this.p2pConnections[connectionId]){
								_this.p2pConnections[connectionId].close();
							}

							if(_this.recorder && roomNotification.event === 'screenshareStopped'){
								_this.recorder.addToEventLog({userId: roomNotification.userId, meetingUserId: roomNotification.meetingUserId, event: 'screenshareStopped'});
							}
						}
                        else if(roomNotification.event === 'userLeft'){
                        	// Kill all connections for user
							const userId = roomNotification.userId;

							for(let connectionTag in _this.activeConnections) {
								// Close all connections tagged userId, userId_screenFromMe, userId_screenFromThem
								if(connectionTag.includes(userId)){
									const connectionId = _this.activeConnections[connectionTag];
									if(_this.p2pConnections[connectionId]){
										_this.p2pConnections[connectionId].close();
									}
								}
							}

							if(_this.recorder){
								_this.recorder.addToEventLog({userId: roomNotification.userId, meetingUserId: roomNotification.meetingUserId, event: 'userLeft'});
							}
						}
                        else if(roomNotification.event === 'videoMuted' || roomNotification.event === 'videoUnmuted'){
                            // Inform peers of video muted status for connections stats
                        	const mutedStatus = (roomNotification.event === 'videoMuted');

                        	const connectionId = _this.activeConnections[roomNotification.userId];
							if(connectionId && _this.p2pConnections[connectionId]){
								_this.p2pConnections[connectionId].setRemoteVideoMuted(mutedStatus);
							}
						}
                    };

                    _this.signallingClient.onDisconnect = function(reason){
                        if (!_this.isUnregistering) {
                            if(_this.reRegisterBackoff === 1000){
                                _this.onNotification(12, 'Unexpected disconnect');
                                // Stop screenshare on unexpected disconnect
                                if(_this.localMediaScreen){
                                    _this.stopScreenshare();
                                    _this.onNotification(11, 'Screenshare stopped');
                                }
                            }

                            const reconnect = function(){
                                // ReRegister
                                _this.signallingClient.register(options.token)
                                .then(function (channels) {
                                    if(_this.enableLogging){
                                        console.log('%c' + 'Reregistered, restarting peer connections...', 'color:palevioletred; font-weight:bold');
                                    }

                                    _this.reRegisterBackoff = 1000; // reset for next time

                                    // Opening p2p connections for each connected user
                                    _this.startPeer2PeerConnections('device');

                                    _this.onNotification(13, 'Successfully reconnected to meeting');

                                })
                                .catch(function(error){
                                    if(error === 'Registration Failed'){
                                        // Token verify failed, stop trying to reconnect
                                        clearTimeout(_this.reconnectAttempt);
                                        _this.reRegisterBackoff = 1000; // reset for next time

                                        _this.onNotification(14, 'Token invalid, reconnect not possible, leaving...');
                                        _this.leave();
                                    }
                                    else{
                                        // Back off our reregister attempts as they continue to fail to avoid runaway process.
                                        if (_this.reRegisterBackoff < _this.maxRegisterBackoff){
                                            _this.reRegisterBackoff += _this.reRegisterBackoff;
                                        }

                                        if(_this.enableLogging){
                                            console.log('%c' + 'Reregistration failed, trying again in:', 'color:palevioletred; font-weight:bold', _this.reRegisterBackoff + 'ms');
                                        }

                                        _this.reconnectAttempt = setTimeout(function(){reconnect()}, _this.reRegisterBackoff);
                                    }
                                })
                            };

                            _this.reconnectAttempt = setTimeout(function(){reconnect()}, _this.reRegisterBackoff);
                        }
                    };

                    _this.signallingClient.register(options.token)
                    .then(function (channels) {
                        if(_this.enableLogging){
                            console.log('%c' + 'Registered successfully', 'color:palevioletred; font-weight:bold');
                        }

                        _this.channel = channels[0];

                        // Connect to registered peers here
						_this.startPeer2PeerConnections('device');

                        resolve(channels);	// Channel list like FM register
                    })
					.catch(function(error){
                    	console.error('Registration error:', error);

                        reject(new AdiaLive5Error(21, error));
					})
                }
                else{
                    // Client(gatewayUrl: string, applicationId: string, userId: string, deviceId: string, clientId: string, roles: string[])
                    //this.client = new liveswitch.Client(this.gatewayURL, options.applicationID, options.userId, this.deviceID);
                    _this.client = new liveswitch.Client(options.url + '/sync', options.applicationId, options.userId, options.deviceId, options.clientId, options.clientRoles);

                    // Workaround for websocket errors
                    _this.client.setDisableWebSockets(true);

                	_this.client.setUserAlias(_this.meetingUserId);

                    // New stuff for restoring broken connections
                    _this.client.addOnStateChange(function (client) {
                    if (client.getState() == liveswitch.ClientState.Registering) {
                            //console.log('client is registering');
                        }
                    else if (client.getState() == liveswitch.ClientState.Registered) {
                            //console.log('client is registered');
                        }
                    else if (client.getState() == liveswitch.ClientState.Unregistering) {
                            //console.log('client is unregistering');
                        }
                    else if (client.getState() == liveswitch.ClientState.Unregistered) {
                            //console.log('client is unregistered');
                            // Client has failed for some reason:
                            // We do not need to `c.closeAll()` as the client handled this for us as part of unregistering
                            if (!_this.isUnregistering) {
                                if(_this.reRegisterBackoff === 1000){
                                    _this.onNotification(12, 'Unexpected disconnect');
                                    // Stop screenshare on unexpected disconnect
                                    if(_this.localMediaScreen){
                                        _this.stopScreenshare();
                                        _this.onNotification(11, 'Screenshare stopped');
                                    }
                                }

                                _this.reconnectAttempt = setTimeout(function(){
                                    // ReRegister
                                    _this.client.register(options.token)
                                    .then(function (channels) {
                                        _this.reRegisterBackoff = 1000; // reset for next time

                                        _this.onNotification(13, 'Successfully reconnected to meeting');
                                        _this.onClientRegistered(channels, options);
                                    })
                                    .fail(function(error){
                                        if(error.message.toLowerCase().includes('tokenexpired')){
                                            clearTimeout(_this.reconnectAttempt);
                                            _this.reRegisterBackoff = 1000; // reset for next time

                                            _this.onNotification(14, 'Token expired, reconnect not possible, leaving...');
                                            _this.leave();
                                        }
                                    })
                                }, _this.reRegisterBackoff);

                                // Back off our reregister attempts as they continue to fail to avoid runaway process.
                                if (_this.reRegisterBackoff < _this.maxRegisterBackoff){
                                    _this.reRegisterBackoff += _this.reRegisterBackoff;
                                }
                            }
                        }
                    });

                    _this.client.register(options.token)
                    .then(function(channels) {
                        _this.onClientRegistered(channels, options);

                        resolve(channels);
                    })
                    .fail(function(error){
                        reject(error)
                    });
                }
            })

        })
    }

    unregister(){
        const _this = this;

        if(!this.client){
            return Promise.resolve('Not registered')
        }

        return new Promise(function (resolve, reject) {
            _this.isUnregistering = true;

            if(_this.connectionMode === 'adiaP2P'){
            	for(let connectionId in _this.p2pConnections){
                    const connection = _this.p2pConnections[connectionId];

                    connection.close();
                }

				_this.signallingClient.unregister();

				_this.channel = null;

                resolve('Unregistered');
            }
            else{
                _this.client.unregister()
                .then(function(result) {
                    _this.channel = null;

                    resolve(result);
                })
                .fail(function(error){
                    reject(error)
                })
            }
        })
    }

    startStatsCollector(userConnection){
        const _this = this;
        userConnection.webRTCHandler = _this;

        const userId = userConnection.userId;
        if(this.statsCollectors[userId]){
            this.statsCollectors[userId].stop();
        }

        if(this.browser && this.browser.name === 'Edge' && parseInt(this.browser.major) < 78){
            return;
        }

        const statsCollector = new LiveSwitchConnectionStats(userConnection);
        statsCollector.start();

        this.statsCollectors[userId] = statsCollector;
    }

    stopStatsCollector(userId){
        if(this.statsCollectors[userId]){
            this.statsCollectors[userId].stop();
            delete this.statsCollectors[userId];
        }
    }

    startSettingsMode(settingsOptions){
        const _this = this;

        this.settingsOptions = settingsOptions;

        if(this.communicationMode === 'none'){
            return Promise.resolve(this.getSettingsComponents());
        }

        return new Promise(function (resolve, reject) {
            _this.loadDeviceLists();

            _this.devicesLoadedPromise
            .then(function(){
                return _this.startLocalMedia()     // Returns existing if already started
                .then(function(){
                    if((_this.communicationMode === 'audio' || _this.communicationMode === 'both') && settingsOptions.onAudioLevel){
                        _this.localMedia.addOnAudioLevel(settingsOptions.onAudioLevel);
                    }

                    resolve(_this.getSettingsComponents());
                })
                .catch(function(error){
                    reject(error)
                });
            })
            .catch(function(error){
                reject(error)
            })
        })
    }

    stopSettingsMode(){
        const _this = this;

        // Remove preview window audio level
        if (_this.localMedia && _this.settingsOptions && _this.settingsOptions.onAudioLevel){
            _this.localMedia.removeOnAudioLevel(_this.settingsOptions.onAudioLevel);
        }

        this.settingsOptions = null;

        return new Promise(function (resolve, reject) {
            if(!_this.getIsConnected()){
                _this.stopLocalMedia()
                .then(function(){
                    resolve(_this.getUserView())
                })
                .catch(function(error){
                    reject(error)
                })
            }
            else{
                resolve(_this.getUserView());
            }
        })
    }

    getSettingsComponents(){
        return {
            view: this.view,
            micDeviceList: (this.devices && this.devices.audio) ? this.devices.audio.map(device => device._name) : null,
            camDeviceList: (this.devices && this.devices.video) ? this.devices.video.map(device => device._name) : null,
            currentSettings: LiveSwitchDeviceHelper.getCurrentSettings(this.localMedia),
            communicationMode: this.communicationMode
        }
    }

    startScreenshare(){
        const _this = this;

        if(this.localMediaScreen){
            const userView = {
                userId: _this.client.getUserId(),
                view: this.localMediaScreen.getView(),
                type: 'screen'
            };

            return Promise.resolve(userView);
        }

        return new Promise(function(resolve, reject){
            const vidOptions = {
                width: {ideal: 1920},
                height: {ideal: 1080},
                frameRate: {ideal: 5},
            };

            _this.localMediaScreen = new liveswitch.LocalMedia(false, vidOptions, true);

            // Catch external stop from browser
            _this.localMediaScreen.addOnVideoStopped(function(){
                // Workaround for duplicated event in FM libs, normally only started connections can be stopped
                if(_this.localMediaScreen.getState() === liveswitch.LocalMediaState.Started){
                    _this.stopScreenshare();

                    _this.onNotification(11, 'Screenshare stopped');
                }
            });

            _this.localMediaScreen.start()
            .then(function(localMedia){
                if(_this.connectionMode === 'liveSwitchSfu'){
                    _this.openSfuUpstreamConnection('screen');
                }
                else if(_this.connectionMode === 'liveSwitchPeer' || _this.connectionMode === 'adiaP2P'){
                    _this.startPeer2PeerConnections('screen');

                    if(_this.recorder){
						_this.recorder.addToEventLog({userId: _this.client.getUserId(), meetingUserId: _this.client.getUserAlias(), event: 'screenshareStarted'});

						const stream = _this.getNativeStream(_this.localMediaScreen);
                        _this.recorder.addStream('local_screen', 'localScreenStream', _this.meetingUserId, stream)
						.then(function (result) {
							const userView = {
								userId: _this.client.getUserId(),
								view: localMedia.getView(),
								type: 'screen'
							};

							resolve(userView);
						})
						.catch(function(error){
							reject(new AdiaLive5Error(62));
						})
                    }
                }

                // No recorder, nothing more to do
                if(!_this.recorder){
                    const userView = {
                        userId: _this.client.getUserId(),
                        view: localMedia.getView(),
                        type: 'screen'
                    };

                    resolve(userView);
                }
            })
            .fail(function(error){
                _this.localMediaScreen = null;

                reject(new AdiaLive5Error(12, error));
            })
        });


    }

    stopScreenshare(){
        const _this = this;

		if(!this.localMediaScreen){
			return Promise.resolve('No screenshare found')
		}

        return new Promise(function (resolve, reject) {
			if(_this.recorder){
				_this.recorder.removeStream('local_screen');
			}

			if(_this.connectionMode === 'liveSwitchSfu' && _this.sfuUpstreamConnectionScreen){
				_this.sfuUpstreamConnectionScreen.close();
			}
			else if(_this.connectionMode === 'liveSwitchPeer' || _this.connectionMode === 'adiaP2P'){
				_this.stopPeer2PeerConnections('screen');
			}

			_this.localMediaScreen.stop()
			.then(function(result){
				if(_this.recorder){
					_this.recorder.addToEventLog({userId: _this.client.getUserId(), meetingUserId: _this.client.getUserAlias(), event: 'screenshareStopped'});
				}

				_this.localMediaScreen = null;

				resolve('Screenshare stopped');
			})
			.fail(function(error){
				reject(new AdiaLive5Error(26, error));
			})
        })
    }

    // To handle page close / refresh
    forceQuit(){
        if(this.connectionMode === 'liveSwitchSfu' && this.sfuUpstreamConnectionScreen){
            this.sfuUpstreamConnectionScreen.close();
        }
        else if(this.connectionMode === 'liveSwitchPeer' || this.connectionMode === 'adiaP2P'){
            this.stopPeer2PeerConnections('screen')
        }

        if(this.localMediaScreen){
            this.localMediaScreen.stop();
            this.localMediaScreen.destroy();
        }

        if(this.connectionMode === 'liveSwitchSfu' && this.sfuUpstreamConnection){
            this.sfuUpstreamConnection.close();
        }
        else if(this.connectionMode === 'liveSwitchPeer' || this.connectionMode === 'adiaP2P'){
            this.stopPeer2PeerConnections('device')
        }

        if(this.localMedia){
            this.localMedia.stop();
            this.localMedia.destroy();
        }

        if(this.connectionMode.includes('liveSwitch') && this.client) {
            this.client.unregister();
        }
        else if(this.connectionMode === 'adiaP2P' && this.signallingClient){
            this.signallingClient.unregister();
        }
    }

    startRecording(){
        if((this.connectionMode !== 'liveSwitchPeer' && this.connectionMode !== 'adiaP2P') || !this.meetingId){
            console.error('Could not start recorder, no P2P connection found');
            return Promise.reject(new AdiaLive5Error(61));
        }

        const _this = this;

        return new Promise(function (resolve, reject) {
            const opts = {
                meetingId : _this.meetingId,
                meetingInfo: _this.meetingInfo
            }

            const pendingJobs = [];

            _this.recorder = new AdiaLive5P2PRecorder(opts);
            _this.recorder.init()
            .then(function(){
                const recorderStartPromise = _this.recorder.startRecording()
                .then(function(){
                    if(_this.localMedia){
						const stream = _this.getNativeStream(_this.localMedia);
                        const addLocalStreamPromise = _this.recorder.addStream('local', 'localStream', _this.meetingUserId, stream);

                        pendingJobs.push(addLocalStreamPromise);
                    }
                    if(_this.localMediaScreen){
						const stream = _this.getNativeStream(_this.localMediaScreen);
                        const addLocalScreenStreamPromise = _this.recorder.addStream('local_screen', 'localScreenStream', _this.meetingUserId, stream);

                        pendingJobs.push(addLocalScreenStreamPromise);
                    }

                    // Add streams for all current connections
                    for (let userId in _this.activeConnections) {
                        const connectionId = _this.activeConnections[userId];
                        const connection = _this.p2pConnections[connectionId];
                        if(connection && !connection.getTag().endsWith('screenFromMe')){
                            const addRemoteStreamPromise = _this.addRemoteStream(connection);

                            pendingJobs.push(addRemoteStreamPromise);
                        }
                    }
                });

                pendingJobs.push(recorderStartPromise);

                Promise.all(pendingJobs)
                .then(function(){
					_this.recorder.addToEventLog({userId: _this.client.getUserId(), meetingUserId: _this.client.getUserAlias(), event: 'recordingStarted'});

                    resolve('Started successfully')
                })
                .catch(function(ex){
                    console.error('Could not start recorder:', ex);

                    // Seems to need a moment before it can be stopped
                    setTimeout(function(){
                        _this.stopRecording()
                        .then(function(){
                        	setTimeout(function(){
								AdiaLive5P2PRecorder.deleteRecording(_this.meetingId)
								.then(function(){
									reject(new AdiaLive5Error(61, ex));
                                })
							}, 500);
            			})
                    }, 500)
        		})
            })
        })
    }

    stopRecording(){
        if(this.recorder){
			this.recorder.addToEventLog({userId: this.client.getUserId(), meetingUserId: this.client.getUserAlias(), event: 'recordingStopped'});

            this.recorder.stopRecording();
            this.recorder = null;
        }

        return Promise.resolve('Recorder stopped');
    }

    getRecordingList(){
        return AdiaLive5P2PRecorder.getRecordingInfos();
    }

    downloadRecording(meetingId){
		return AdiaLive5P2PRecorder.downloadRecording(meetingId);
	}

	getTimeline(meetingId){
		return AdiaLive5P2PRecorder.getTimeline(meetingId);
	}

	deleteRecording(meetingId){
		return AdiaLive5P2PRecorder.deleteRecording(meetingId);
	}

	getConnectionDuration(){
        if(this.connected > 0){
            return Date.now() - this.connected;
        }
        else{
            return 0;
        }
    }

    // Connection Functions
    openSfuUpstreamConnection(mediaSource) {
        const _this = this;

        const connectionInfo = {};
        if(mediaSource === 'screen') {
            connectionInfo.userId = this.client.getUserId() + '_screen';
            connectionInfo.localMedia = this.localMediaScreen;
        }
        else{
            connectionInfo.userId = this.client.getUserId();
            connectionInfo.localMedia = this.localMedia;
        }

        if(!connectionInfo.localMedia){
            return null;
        }

        const audioStream = (connectionInfo.localMedia.getAudioTrack()) ? new liveswitch.AudioStream(connectionInfo.localMedia) : null;
        const videoStream = (connectionInfo.localMedia.getVideoTrack()) ? new liveswitch.VideoStream(connectionInfo.localMedia) : null;

        // Simulcast
        if(videoStream && this.useSimulcast){
            //console.log('%c' + 'Setting simulcast mode for upstream', 'color:#F333FF;font-weight:bold;');
            videoStream.setSimulcastMode(liveswitch.SimulcastMode.RtpStreamId);

            videoStream.addOnLocalEncodingEnabled(function(encoding){
                _this.statsCollectors[connectionInfo.userId].simulcastChanged(_this.getNumConnections());
            })

            videoStream.addOnLocalEncodingDisabled(function(encoding){
                _this.statsCollectors[connectionInfo.userId].simulcastChanged(_this.getNumConnections());
            })
        }

        const connection = this.channel.createSfuUpstreamConnection(audioStream, videoStream);

        if(mediaSource === 'screen'){
            this.sfuUpstreamConnectionScreen = connection;
        }
        else{
            this.sfuUpstreamConnection = connection;
        }

		connection.setIceServers(this.iceServers);
		connection.setDisableAutomaticIceServers(!!this.iceServers);

		if(this.iceGatherPolicy){
			connection.setIceGatherPolicy(this.iceGatherPolicy);
		}

        connection.setTag(connectionInfo.userId);
        connection.addOnStateChange(function (connection){
            if(_this.enableLogging){
                console.log('%c' + _this.getTime() + ' ' + connection.getId() + ' (' + connection.getTag() + ') ' + new liveswitch.ConnectionStateWrapper(connection.getState()).toString(), 'color:coral; font-weight:bold');
            }

            // Cleanup if the connection closes or fails.
            if (connection.getState() === liveswitch.ConnectionState.Closing ||
                connection.getState() === liveswitch.ConnectionState.Failing) {
                if (connection.getRemoteClosed()) {
                    if(_this.enableLogging){
                        console.log('%c' + _this.getTime() + ' ' + connection.getId() + ': Media server closed the connection.', 'color:coral; font-weight:bold');
                    }
                }

                if(mediaSource === 'screen'){
                    _this.sfuUpstreamConnectionScreen = null;
                }
                else{
                    _this.connected = 0;
                    _this.sfuUpstreamConnection = null;
                }

                _this.stopStatsCollector(connection.getTag());

                delete _this.activeConnections[connection.getTag()];
            }
            else if (connection.getState() === liveswitch.ConnectionState.Failed) {
                _this.onNotification(15, connection.getError().getMessage());

                // Note: no need to close the connection as it's done for us.
                _this.openSfuUpstreamConnection(mediaSource);
            }
            else if (connection.getState() === liveswitch.ConnectionState.Connected) {
                if(mediaSource !== 'screen'){
                    // Log connection start time for uptime
                    _this.connected = Date.now();

                    // Start connection stats collector
                    const userConnection = {
                        userId: connection.getTag(),
                        connection: connection,
                        maxVideoBitrate: _this.maxVideoBitrate
                    };

                    _this.startStatsCollector(userConnection);

                    // Simulcast
                    if(_this.useSimulcast){
                        _this.statsCollectors[userConnection.userId].simulcastChanged(_this.getNumConnections());
                    }
                }
            }
        });

        connection.open();

        return connection;
    }

    openSfuDownstreamConnection(remoteConnectionInfo) {
        const _this = this;

        const remoteMedia = new liveswitch.RemoteMedia();
        remoteMedia.setAudioMuted(false);
        remoteMedia.setVideoMuted(false);

        if (remoteMedia.getView()) {
            remoteMedia.getView().id = 'remoteView_' + remoteMedia.getId();
        }

        const audioStream = (remoteConnectionInfo.getHasAudio()) ? new liveswitch.AudioStream(remoteMedia) : null;
        const videoStream = (remoteConnectionInfo.getHasVideo()) ? new liveswitch.VideoStream(remoteMedia) : null;

        // Simulcast
        if(videoStream && this.useSimulcast){
            // Set starting quality
            const encodings = remoteConnectionInfo.getVideoStream().getSendEncodings();

            if(encodings && encodings.length > 1) {
                videoStream.setRemoteEncoding(encodings[0]);
            }

        }

        const connection = this.channel.createSfuDownstreamConnection(remoteConnectionInfo, audioStream, videoStream);
        this.sfuDownstreamConnections[connection.getId()] = connection;

		connection.setIceServers(this.iceServers);
		connection.setDisableAutomaticIceServers(!!this.iceServers);

		if(this.iceGatherPolicy){
			connection.setIceGatherPolicy(this.iceGatherPolicy);
		}

        connection.setTag(remoteConnectionInfo.getTag());
        connection.addOnStateChange(function (connection) {
            if(_this.enableLogging){
                console.log('%c' + _this.getTime() + ' ' + connection.getId() + ' (' + connection.getTag() + ') ' + new liveswitch.ConnectionStateWrapper(connection.getState()).toString(), 'color:coral; font-weight:bold');
            }

            const isScreenshare = connection.getTag().endsWith('_screen');

            // Cleanup if the connection closes or fails.
            if (connection.getState() == liveswitch.ConnectionState.Closing ||
                connection.getState() == liveswitch.ConnectionState.Failing) {
                if (connection.getRemoteClosed()) {
                    if(_this.enableLogging){
                        console.log('%c' + _this.getTime() + ' ' + connection.getId() +': Media server closed the connection.', 'color:coral; font-weight:bold');
                    }
                }

                remoteMedia.destroy();

                delete _this.sfuDownstreamConnections[connection.getId()];

                // Only react to active connections, ignore connections that have already been replaced
                if(connection.getId() === _this.activeConnections[connection.getTag()]){
                    _this.stopStatsCollector(connection.getTag());

                    delete _this.activeConnections[connection.getTag()];

                    const userView = {
                        userId: remoteConnectionInfo.getUserId(),
                        type: (isScreenshare) ? 'screen' : 'remote'
                    };

                    if(_this.adaptiveQuality && userView.type !== 'screen'){
                        _this.removeAdaptiveQuality(userView.userId);
                    }

                    _this.onUserLeft(userView);
                }
			}
            else if (connection.getState() == liveswitch.ConnectionState.Failed){
                _this.onNotification(15, connection.getError().getMessage());

                // Note: no need to close the connection as it's done for us.
                _this.openSfuDownstreamConnection(remoteConnectionInfo);
            }
            else if(connection.getState() == liveswitch.ConnectionState.Connected){
                const existingUserConnection = _this.activeConnections[connection.getTag()];
                if(existingUserConnection){
                    const oldConnection = _this.sfuDownstreamConnections[existingUserConnection];
                    if(oldConnection){
                        oldConnection.close();
                    }
                }

                _this.activeConnections[connection.getTag()] = connection.getId();

                // Start stats collector
                if(!isScreenshare){
                    const userConnection = {
                        userId: connection.getTag(),
                        connection: connection,
                        maxVideoBitrate: _this.maxVideoBitrate
                    };

                    _this.startStatsCollector(userConnection);

                    if(_this.useSimulcast){
                        _this.statsCollectors[userConnection.userId].simulcastChanged(_this.getNumConnections());
                    }
                }

                // Add audio level
                if(remoteConnectionInfo.getHasAudio()){
                    remoteMedia.addOnAudioLevel(function(audioLevel){
                        const userAudioLevel = {
                            userId: connection.getTag(),
                            audioLevel: audioLevel,
                        };

                        _this.onAudioLevel(userAudioLevel);
                    });
                }

                // Add user Id to view to link view changes to user
                const remoteUserId = remoteConnectionInfo.getUserId();
                const remoteView = (remoteMedia.getView()) ? remoteMedia.getView() : null
                if(remoteView && !isScreenshare){
                    remoteView.classList.add('remote_' + remoteUserId);
                }

                const userView = {
                    userId: remoteUserId,
                    view: remoteView,
                    type: (isScreenshare) ? 'screen' : 'remote'
                };

                if(videoStream && _this.adaptiveQuality && userView.type !== 'screen'){
                    _this.addAdaptiveQuality(userView.userId, userView.view);
                }

                // IOS audio issue fix
                if(remoteView && _this.communicationMode === 'none' && _this.browser && _this.browser.name.toLowerCase().includes('safari')){
                    const localMedia = new liveswitch.LocalMedia(true, false);
                    localMedia.start()
                    .then(function(){
                        localMedia.stop();
                        localMedia.destroy();
                    })
                }

                _this.onUserJoined(userView);
            }
        });

        connection.open();

        return connection;
    }

    openLiveSwitchPeerOfferConnection(mediaSource, remoteClientInfo) {
        const _this = this;

        const targetLocalMedia = (mediaSource === 'screen') ? this.localMediaScreen : this.localMedia;

        const remoteMedia = new liveswitch.RemoteMedia();
        remoteMedia.setAudioMuted(false);
        remoteMedia.setVideoMuted(false);

        if(remoteMedia.getView()) {
            remoteMedia.getView().id = 'remoteView_' + remoteMedia.getId();
        }

        const audioTrack = (targetLocalMedia) ? targetLocalMedia.getAudioTrack() : null;
        const videoTrack = (targetLocalMedia) ? targetLocalMedia.getVideoTrack() : null;

        const audioStream = new liveswitch.AudioStream(audioTrack, remoteMedia);
        const videoStream = new liveswitch.VideoStream(videoTrack, remoteMedia);

        // Name connections after remote user so stats show under relevant user
        let connectionTag = remoteClientInfo.getUserId();
        if(mediaSource === 'screen'){
            connectionTag += '_screenFromMe';
        }

        const connection = this.channel.createPeerConnection(remoteClientInfo, audioStream, videoStream);

        this.p2pConnections[connection.getId()] = connection;

		connection.setIceServers(this.iceServers);
		connection.setDisableAutomaticIceServers(!!this.iceServers);

		if(this.iceGatherPolicy){
			connection.setIceGatherPolicy(this.iceGatherPolicy);
		}

        // Set identifiers
        connection.setTag(connectionTag);
        connection.setDynamicValue('meetingUserId', remoteClientInfo.getUserAlias());

        connection.addOnStateChange(function (connection) {
            if(_this.enableLogging){
                console.log('%c' + _this.getTime() + ' ' + connection.getId() + ' (' + connection.getTag() + ') ' + new liveswitch.ConnectionStateWrapper(connection.getState()).toString(), 'color:coral; font-weight:bold');
            }

            // Cleanup if the connection closes or fails.
            if (connection.getState() === liveswitch.ConnectionState.Closing ||
                connection.getState() === liveswitch.ConnectionState.Failing) {
                if (connection.getRemoteRejected()) {
                    if(_this.enableLogging){
                        console.log('%c' + _this.getTime() + ' ' + connection.getId() + ': Remote peer rejected the offer.', 'color:coral; font-weight:bold');
                    }
                }
                else if (connection.getRemoteClosed()) {
                    if(_this.enableLogging){
                        console.log('%c' + _this.getTime() + ' ' + connection.getId() + ': Remote peer closed the connection.', 'color:coral; font-weight:bold');
                    }
                }

                remoteMedia.destroy();

                delete _this.p2pConnections[connection.getId()];

                // Only react to active connections, ignore connections that have already been replaced
				const clientId = connection.getTag();
                if(connection.getId() === _this.activeConnections[clientId]){
                    _this.stopStatsCollector(clientId);

                    delete _this.activeConnections[clientId];

                    // No remote media on own screenshare
                    if(!clientId.endsWith('_screenFromMe')){
						if(_this.recorder){
							_this.recorder.removeStream(connection.getTag());
						}

                        const userView = {
                            userId: remoteClientInfo.getUserId(),
                            type: 'remote'
                        };

                        _this.onUserLeft(userView);
                    }
                }
                else{
                    //console.log('%c' + connection.getId() + 'Connection is no longer active, ignoring...', 'color:red; font-weight:bold');
                }
            }
            else if (connection.getState() === liveswitch.ConnectionState.Failed) {
				_this.onNotification(15, connection.getError().getMessage());

                // Note: no need to close the connection as it's done for us.
                _this.openLiveSwitchPeerOfferConnection(mediaSource, remoteClientInfo);
            }
            else if (connection.getState() === liveswitch.ConnectionState.Connected) {
                const previousConnectionId = _this.activeConnections[connection.getTag()];
                if(previousConnectionId){
                    const oldConnection = _this.p2pConnections[previousConnectionId];
                    if(oldConnection){
                        oldConnection.close();
                    }
                }

                // Keep track of which is the current active connection for a user
                _this.activeConnections[connection.getTag()] = connection.getId();

                // Screenshare has no remote media
                if(mediaSource !== 'screen') {
                    const userConnection = {
                        userId: connection.getTag(),
                        connection: connection
                    };

                    _this.startStatsCollector(userConnection);

                    remoteMedia.addOnAudioLevel(function(audioLevel){
                        const userAudioLevel = {
                            userId: connection.getTag(),
                            audioLevel: audioLevel,
                        };

                        _this.onAudioLevel(userAudioLevel);
                    });

                    if(_this.recorder){
                        _this.addRemoteStream(connection)
                        .catch(function(ex){
                            _this.onError(62, ex);
                        });
                    }

                    const remoteUserId = remoteClientInfo.getUserId();
                    const remoteView = (remoteMedia.getView()) ? remoteMedia.getView() : null
                    if(remoteView){
                        remoteView.classList.add('remote_' + remoteUserId);
                    }

                    const userView = {
                        userId: remoteUserId,
                        view: remoteView,
                        type: 'remote'
                    };

                    _this.onUserJoined(userView);
                }
            }
        });

        // Open the connection (sends an offer to the remote peer).
        connection.open();
        return connection;
    }

    openLiveSwitchPeerAnswerConnection(peerConnectionOffer) {
        const _this = this;

        let peerSendingAudio = false;
        let peerSendingVideo = false;
        const mediaDescriptions = peerConnectionOffer.getOffer().getSdpMessage().getMediaDescriptions();
        for (let i = 0; i < mediaDescriptions.length; i++) {
            const mediaDescription = mediaDescriptions[i];

            if(mediaDescription.getIsAudio() && mediaDescription.getStreamDirection() === 1){     // 1 = sendrecv
                peerSendingAudio = true;
            }
            else if(mediaDescription.getIsVideo() && mediaDescription.getStreamDirection() === 1){
                peerSendingVideo = true;
            }
        }

        // Reject peer offer if both peers receive only, but offer screen if currently sharing
        if(!peerSendingAudio && !peerSendingVideo && this.communicationMode === 'none'){
            this.channel.rejectPeerConnection(peerConnectionOffer);

            const remoteClientInfo = peerConnectionOffer.getRemoteClientInfo()

            // Offer screenshare connection if sharing screen
            if(_this.localMediaScreen && !_this.activeConnections[remoteClientInfo.getUserId() + '_screenFromMe']){
                _this.openLiveSwitchPeerOfferConnection('screen', remoteClientInfo);
            }

            return null;
        }

        const remoteMedia = new liveswitch.RemoteMedia();
        remoteMedia.setAudioMuted(false);
        remoteMedia.setVideoMuted(false);

        if (remoteMedia.getView()) {
            remoteMedia.getView().id = 'remoteView_' + remoteMedia.getId();
        }

        const remoteClientInfo = peerConnectionOffer.getRemoteClientInfo();

        // Screenshares are 1 way so we only receive
        const isScreenshare = peerConnectionOffer.getConnectionTag().includes('_screen');

		let audioTrack = null;
		let videoTrack = null;
        if(!isScreenshare && this.localMedia){
			audioTrack = this.localMedia.getAudioTrack();
			videoTrack = this.localMedia.getVideoTrack();
		}

        const audioStream = (peerConnectionOffer.getHasAudio()) ? new liveswitch.AudioStream(audioTrack, remoteMedia) : null;
        const videoStream = (peerConnectionOffer.getHasVideo()) ? new liveswitch.VideoStream(videoTrack, remoteMedia) : null;

        const connection = this.channel.createPeerConnection(peerConnectionOffer, audioStream, videoStream);
        this.p2pConnections[connection.getId()] = connection;

        // Name connections after remote user so stats show under relevant user
        let connectionTag = remoteClientInfo.getUserId();
        if(isScreenshare){
            connectionTag += '_screenFromThem';
        }

		connection.setIceServers(this.iceServers);
		connection.setDisableAutomaticIceServers(!!this.iceServers);

		if(this.iceGatherPolicy){
			connection.setIceGatherPolicy(this.iceGatherPolicy);
		}

        // Set identifiers
        connection.setTag(connectionTag);
		connection.setDynamicValue('meetingUserId', remoteClientInfo.getUserAlias());

        connection.addOnStateChange(function(connection) {
            if(_this.enableLogging){
                console.log('%c' + _this.getTime() + ' ' + connection.getId() + ' (' + connection.getTag() + ') ' + new liveswitch.ConnectionStateWrapper(connection.getState()).toString(), 'color:coral; font-weight:bold');
            }

            // Cleanup if the connection closes or fails.
            if (connection.getState() === liveswitch.ConnectionState.Closing ||
                connection.getState() === liveswitch.ConnectionState.Failing) {
                if (connection.getRemoteRejected()) {
                    if(_this.enableLogging){
                        console.log('%c' + _this.getTime() + ' ' + connection.getId() + ': Remote peer rejected the offer.', 'color:coral; font-weight:bold');
                    }
                }
                else if (connection.getRemoteClosed()) {
                    if(_this.enableLogging){
                        console.log('%c' + _this.getTime() + ' ' + connection.getId() + ': Remote peer closed the connection.', 'color:coral; font-weight:bold');
                    }
                }

                remoteMedia.destroy();

                delete _this.p2pConnections[connection.getId()];

                // Only react to active connections, ignore connections that have already been replaced
                if(connection.getId() === _this.activeConnections[connection.getTag()]){
                    _this.stopStatsCollector(connection.getTag());

                    delete _this.activeConnections[connection.getTag()];

					if(_this.recorder){
						if(isScreenshare){
							const remoteClientInfo = peerConnectionOffer.getRemoteClientInfo();
							_this.recorder.addToEventLog({userId: remoteClientInfo.getUserId(), meetingUserId: remoteClientInfo.getUserAlias(), event: 'screenshareStopped'});
						}

						_this.recorder.removeStream(connection.getTag());
					}

                    const userView = {
                        userId: remoteClientInfo.getUserId(),
                        type: (isScreenshare) ? 'screen' : 'remote'
                    };

                    _this.onUserLeft(userView);
                }
            }
            else if (connection.getState() === liveswitch.ConnectionState.Failed) {
                _this.onNotification(15, connection.getError().getMessage());

                // Note: no need to close the connection as it's done for us.
                // Note: do not offer a new answer here. Let the offerer reoffer and then we answer normally.
            }
            else if (connection.getState() === liveswitch.ConnectionState.Connected) {
                const previousConnectionId = _this.activeConnections[connection.getTag()];
                if(previousConnectionId){
                    const oldConnection = _this.p2pConnections[previousConnectionId];
                    if(oldConnection){
                        oldConnection.close();
                    }
                }

                // Keep track of which is the current active connection for a user
                _this.activeConnections[connection.getTag()] = connection.getId();

                if(!isScreenshare){
                    const userConnection = {
                        userId: connection.getTag(),
                        connection: connection
                    };

                    _this.startStatsCollector(userConnection);
                }

                if(peerConnectionOffer.getHasAudio){
                    remoteMedia.addOnAudioLevel(function(audioLevel){
                        const userAudioLevel = {
                            userId: connection.getTag(),
                            audioLevel: audioLevel,
                        };

                        _this.onAudioLevel(userAudioLevel);
                    });
                }

                // Offer screenshare connection if sharing screen & is a new peer
                if(_this.localMediaScreen && !(connection.getTag().endsWith('_screenFromThem'))){
                    _this.openLiveSwitchPeerOfferConnection('screen', remoteClientInfo);
                }

                if(_this.recorder){
                    _this.addRemoteStream(connection)
					.catch(function(ex){
						_this.onError(62, ex);
					});
                }

                const userView = {
                    userId: remoteClientInfo.getUserId(),
                    view: (remoteMedia.getView()) ? remoteMedia.getView() : null,
                    type: (isScreenshare) ? 'screen' : 'remote'
                };

                _this.onUserJoined(userView);
            }
        });

        // Open the connection (sends an answer to the remote peer).
        connection.open();

        return connection;
    }

    startPeer2PeerConnections(mediaSource){
        if(this.enableLogging){
            console.log('%c' + 'Starting peer connections for:', 'color:palevioletred; font-weight:bold', mediaSource);
        }

        const _this = this;

    	if(this.connectionMode === 'liveSwitchPeer'){
			const remoteClientInfos = this.channel.getRemoteClientInfos();
			for (let i = 0; i < remoteClientInfos.length; i++) {
				const remoteClientInfo = remoteClientInfos[i];

				// Don't try connect to our old connections
				if(remoteClientInfo.getUserId() !== this.client.getUserId()){
					this.openLiveSwitchPeerOfferConnection(mediaSource, remoteClientInfo);
				}
			}
		}
		else if(this.connectionMode === 'adiaP2P' && this.signallingClient){
			this.signallingClient.getParticipantsList(function(participantsList){
                if(_this.enableLogging){
                    console.log('%c' + 'Got participants list:', 'color:palevioletred; font-weight:bold', participantsList);
                }

			    for(let i = 0; i < participantsList.length; i++){
			        const userId = participantsList[i];

					if(userId != _this.client.getUserId()){
                        if(_this.enableLogging){
                            console.log('%c' + 'Starting connection for peer:', 'color:palevioletred; font-weight:bold', participantsList[i]);
                        }

						// Start p2p connections for all connected peers
						_this.openP2POfferConnection(mediaSource, userId);
					}
				}
			})
		}
    }

    stopPeer2PeerConnections(mediaSource){
    	// If screen, close my screen connections, else only close main (never close their screens)
        for (let userId in this.activeConnections) {
            if(mediaSource === 'screen'){
                if(userId.endsWith('_screenFromMe')){
                    const connectionId = this.activeConnections[userId];

                    const connection = this.p2pConnections[connectionId];
                    if(connection){
						connection.close();
                    }
                }
            }
            else{
                if(!userId.includes('_screen')){
                    const connectionId = this.activeConnections[userId];
                    const connection = this.p2pConnections[connectionId];
                    if(connection){
                        connection.close();
                    }
                }
            }
        }

		const event = (mediaSource === 'screen') ? 'screenshareStopped' : 'deviceStopped';
		this.sendRoomNotification(event);
    }

    updateMeetingInfo(meetingInfo){
        if(!this.recorder){
            return Promise.reject(new AdiaLive5Error(63));
        }

        const _this = this;

        return new Promise(function(resolve, reject){
            _this.recorder.updateMeetingInfo(meetingInfo)
            .then(function (result) {
                resolve(result)
            })
            .catch(function(error){
                reject(new AdiaLive5Error(63));
            })
        })
    }

    // Simulcast
    setRemoteQuality(quality, userId){
        const _this = this;

        if(this.connectionMode !== 'liveSwitchSfu'){
            return Promise.reject('Not SFU mode')
        }

        return new Promise(function (resolve, reject) {
            //console.log('%c' + 'setRemoteQuality:', 'color:#F333FF;font-weight:bold;', quality, userId);

            const connection = _this.getConnectionForUser(userId);
            if(connection){
                const videoStream = connection.getRemoteConnectionInfo().getVideoStream();
                if(!videoStream){
                    return Promise.reject('No video stream found')
                }

                let encoding = null;
                const encodings = videoStream.getSendEncodings();

                /*
                // Custom encodings are no longer used
                const targetQuality = _this.qualityPresets[quality];
                for (let i = 0; i < encodings.length; i++) {
                    const enc = encodings[i];
                    if(enc.getBitrate() === targetQuality.bitrate && enc.getFrameRate() === targetQuality.frameRate && Math.abs(enc.getScale()) === targetQuality.scale){
                        encoding = enc;
                        break;
                    }
                }
                 */

                if(quality == 'high'){
                    encoding = encodings[0];
                }
                else if(quality == 'med'){
                    encoding = encodings[1];
                }
                else if(quality == 'low'){
                    encoding = encodings[2];
                }

                //console.log('%c' + 'Setting encoding:', 'color:#F333FF;font-weight:bold;', encoding);

                if(encoding){
                    const config = connection.getConfig();
                    config.setRemoteVideoEncoding(encoding);
                    config.setTag(connection.getTag());         // Must check if tags are still erroneously deleted on update

                    connection.update(config)
                    .then(function(){
                        if(_this.statsCollectors[userId]){
                            _this.statsCollectors[userId].simulcastChanged(_this.getNumConnections());
                        }

                        //console.log('%c' + 'Remote Encoding set to:', 'color:#F333FF;font-weight:bold;', quality);
                        resolve(quality)
                    })
                    .fail(function(error){
                        reject(new AdiaLive5Error(16, error));
                    });
                }
            }
        })
    }

    openP2POfferConnection(mediaSource, peerId){
        const _this = this;

		const targetLocalMedia = (mediaSource === 'screen') ? this.localMediaScreen : this.localMedia;

		const remoteMedia = new liveswitch.RemoteMedia();
		remoteMedia.setAudioMuted(false);
		remoteMedia.setVideoMuted(false);

		if(remoteMedia.getView()) {
			remoteMedia.getView().id = 'remoteView_' + remoteMedia.getId();
		}

		const audioTrack = (targetLocalMedia) ? targetLocalMedia.getAudioTrack() : null;
		const videoTrack = (targetLocalMedia) ? targetLocalMedia.getVideoTrack() : null;

		const audioStream = new liveswitch.AudioStream(audioTrack, remoteMedia);
		const videoStream = new liveswitch.VideoStream(videoTrack, remoteMedia);

		// Name connections after remote user so stats show under relevant user
		let connectionTag = peerId;
		if(mediaSource === 'screen'){
			connectionTag += '_screenFromMe';
		}

        const connection = new liveswitch.Connection([audioStream, videoStream]);
		this.upgradeConnectionObject(connection);

        this.p2pConnections[connection.getId()] = connection;

		const previousConnectionId = _this.activeConnections[connectionTag];
		if(previousConnectionId){
			const oldConnection = _this.p2pConnections[previousConnectionId];
			if(oldConnection){
				oldConnection.close();
			}
		}

		this.activeConnections[connectionTag] = connection.getId();

		connection.setIceServers(this.iceServers);

		if(this.iceGatherPolicy){
			connection.setIceGatherPolicy(this.iceGatherPolicy);
		}

		// Meeting user ID is not known here, is set when they answer
		connection.setTag(connectionTag);

        connection.addOnStateChange(function(connection){
            if(_this.enableLogging){
                console.log('%c' + _this.getTime() + ' ' + connection.getId() + ' (' + connection.getTag() + ') ' + new liveswitch.ConnectionStateWrapper(connection.getState()).toString(), 'color:coral; font-weight:bold');
            }

            // Cleanup if the connection closes or fails.
            if (connection.getState() === liveswitch.ConnectionState.Closing ||
                connection.getState() === liveswitch.ConnectionState.Failing) {

                remoteMedia.destroy();

                delete _this.p2pConnections[connection.getId()];

                // Only react to active connections, ignore connections that have already been replaced
                const clientId = connection.getTag();
                if(connection.getId() === _this.activeConnections[clientId]){
                    _this.stopStatsCollector(clientId);

					delete _this.activeConnections[clientId];

					// Can only be main connection or screen from me
                    if(!clientId.endsWith('_screenFromMe')){
						if(_this.recorder){
							_this.recorder.removeStream(connection.getTag());
						}

                        const userView = {
                            userId: clientId,
                            type: 'remote'
                        };

                        _this.onUserLeft(userView);
                    }
                }
            }
			else if (connection.getState() === liveswitch.ConnectionState.Failed) {
				_this.onNotification(15, connection.getError().getMessage());

				// Note: no need to close the connection as it's done for us
				_this.openP2POfferConnection(mediaSource, peerId);
			}
            else if (connection.getState() === liveswitch.ConnectionState.Connected){
            	const clientId = connection.getTag();

				// My screenshare has no remote media (offer can only be my screenshare)
				if(!(mediaSource === 'screen')) {
                    const userConnection = {
                        userId: clientId,
                        connection: connection
                    };

                    _this.startStatsCollector(userConnection);

					remoteMedia.addOnAudioLevel(function(audioLevel){
						const userAudioLevel = {
							userId: clientId,
							audioLevel: audioLevel,
						};

						_this.onAudioLevel(userAudioLevel);
					});

					if(_this.recorder){
						_this.addRemoteStream(connection);
					}

					const userView = {
						userId: clientId,
						view: (remoteMedia.getView()) ? remoteMedia.getView() : null,
						type: 'remote'
					};

					_this.onUserJoined(userView);
				}
            }
        });

        connection.addOnLocalCandidate(function(connection, candidate){
            const clientId = connection.getTag();

            const msg = {
                senderInfo: {userId: _this.client.getUserId(), userAlias: _this.meetingUserId},
                receiverId: peerId,
                connectionType: (clientId.includes('screen')) ? 'screenFrom_' + _this.client.getUserId() : 'main',
                type: 'candidate',
                dataJSON: candidate.toJson()
            };

            _this.signallingClient.send(msg);
        });

		connection.createOffer()
		.then(function(offer){
			connection.setLocalDescription(offer)
			.then(function(offer){
				const msg = {
					senderInfo: {userId: _this.client.getUserId(), userAlias: _this.meetingUserId},
					receiverId: peerId,
					connectionType: (mediaSource === 'screen') ? 'screenFrom_' + _this.client.getUserId() : 'main',
					type: 'offeranswer',
					dataJSON: offer.toJson()
				};

				_this.signallingClient.send(msg);
			})
			.fail(function(error){
				console.error('Error setting local description:', error)
			})
		})
		.fail(function(error){
			console.error('Error starting signalling. ', error);
		});

        return connection;
    }

	openP2PAnswerConnection(message){
        const _this = this;

		const remoteMedia = new liveswitch.RemoteMedia();
		remoteMedia.setAudioMuted(false);
		remoteMedia.setVideoMuted(false);

		if (remoteMedia.getView()) {
			remoteMedia.getView().id = 'remoteView_' + remoteMedia.getId();
		}

		// Screenshares are 1 way so we only receive
		const isScreenshare = message.connectionType.includes('screenFrom');

		let audioTrack = null;
		let videoTrack = null;
		if(!isScreenshare && this.localMedia){
			audioTrack = this.localMedia.getAudioTrack();
			videoTrack = this.localMedia.getVideoTrack();
		}

		const audioStream = new liveswitch.AudioStream(audioTrack, remoteMedia);
		const videoStream = new liveswitch.VideoStream(videoTrack, remoteMedia);

		// Name connections after remote user so stats show under relevant user
		let connectionTag = message.senderInfo.userId;
		if(isScreenshare){
			connectionTag += '_screenFromThem';
		}

		const connection = new liveswitch.Connection([audioStream, videoStream]);
		this.upgradeConnectionObject(connection);

		this.p2pConnections[connection.getId()] = connection;

		const previousConnectionId = this.activeConnections[connectionTag];
		if(previousConnectionId){
			const oldConnection = _this.p2pConnections[previousConnectionId];
			if(oldConnection){
				oldConnection.close();
			}
		}

		this.activeConnections[connectionTag] = connection.getId();

		connection.setIceServers(this.iceServers);

		if(this.iceGatherPolicy){
			connection.setIceGatherPolicy(this.iceGatherPolicy);
		}

		// Set identifiers
		connection.setTag(connectionTag);
		connection.setDynamicValue('meetingUserId', message.senderInfo.userAlias);

		connection.addOnStateChange(function (connection) {
            if(_this.enableLogging){
                console.log('%c' + _this.getTime() + ' ' + connection.getId() + ' (' + connection.getTag() + ') ' + new liveswitch.ConnectionStateWrapper(connection.getState()).toString(), 'color:coral; font-weight:bold');
            }

			// Cleanup if the connection closes or fails.
			if (connection.getState() === liveswitch.ConnectionState.Closing ||
				connection.getState() === liveswitch.ConnectionState.Failing) {

				remoteMedia.destroy();

				delete _this.p2pConnections[connection.getId()];

				// Only react to active connections, ignore connections that have already been replaced
				const clientId = connection.getTag();
				if(connection.getId() === _this.activeConnections[clientId]){
					_this.stopStatsCollector(clientId);

					delete _this.activeConnections[clientId];

					if(_this.recorder){
						_this.recorder.removeStream(connection.getTag());
					}

					const userView = {
						userId: message.senderInfo.userId,
						type: (isScreenshare) ? 'screen' : 'remote'
					};

					_this.onUserLeft(userView);
				}
			}
			else if (connection.getState() === liveswitch.ConnectionState.Failed) {
				_this.onNotification(15, connection.getError().getMessage());

				// Note: no need to close the connection as it's done for us.
				// Note: do not offer a new answer here. Let the offerer reoffer and then we answer normally.
			}
			else if (connection.getState() === liveswitch.ConnectionState.Connected) {
				const clientId = connection.getTag();

				if(!isScreenshare){
                    const userConnection = {
                        userId: clientId,
                        connection: connection
                    };

                    _this.startStatsCollector(userConnection);

					remoteMedia.addOnAudioLevel(function(audioLevel){
						const userAudioLevel = {
							userId: clientId,
							audioLevel: audioLevel,
						};

						_this.onAudioLevel(userAudioLevel);
					});
				}

				// Offer screenshare connection if currently sharing screen & is a new peer (_screenFromMe existing means was main connection restart)
				if(_this.localMediaScreen && !(clientId.endsWith('_screenFromThem')) && !_this.activeConnections[clientId + '_screenFromMe']){
					_this.openP2POfferConnection('screen', clientId);
				}

				if(_this.recorder){
					_this.addRemoteStream(connection);
				}

				const userView = {
					userId: message.senderInfo.userId,
					view: (remoteMedia.getView()) ? remoteMedia.getView() : null,
					type: (isScreenshare) ? 'screen' : 'remote'
				};

				_this.onUserJoined(userView);
			}
		});

		connection.addOnLocalCandidate(function(connection, candidate){
			const msg = {
				senderInfo: {userId: _this.client.getUserId(), userAlias: _this.meetingUserId},
				receiverId: message.senderInfo.userId,
				connectionType: message.connectionType,
				type: 'candidate',
				dataJSON: candidate.toJson()
			};

			_this.signallingClient.send(msg);
		});

		return connection;
	}

    // Events
    onError(number, exception){
        // exception instanceof Error
        const error = new AdiaLive5Error(number, exception);

        this.webRTCLayer.onError(error);
    }

    onNotification(number, message){
        this.webRTCLayer.onNotification({number: number, message: message});
    }

    onUserJoined(userView){
        if(this.audioAnalyser && userView.type !== 'screen'){
            this.audioAnalyser.userJoined(userView.userId);
        }

        this.webRTCLayer.onUserJoined(userView);
    }

    onUserLeft(userView){
        if(userView.userId === this.client.getUserId()){
            return;
        }

        if(this.audioAnalyser && userView.type !== 'screen'){
            this.audioAnalyser.userLeft(userView.userId);
        }

        this.webRTCLayer.onUserLeft(userView);
    }

    onStatsReceived(userStats){
        // With P2P connections, screenFromMe is not unique, exists for each peer, so stats are difficult
        if(userStats.userId.endsWith('_screen') || userStats.userId.endsWith('_screenFromThem')){
            userStats.userId = userStats.userId.substring(0, userStats.userId.indexOf('_screen'));
            userStats.type = 'screen'
        }
        else if(userStats.userId === this.client.getUserId()){
            userStats.type = 'local';
        }
        else{
            userStats.type = 'remote';
        }

        this.webRTCLayer.onStatsReceived(userStats);
    }

    onAudioLevel(userAudioLevel){
        if(this.audioAnalyser){
            this.audioAnalyser.audioReceived(userAudioLevel);
        }

        this.webRTCLayer.onAudioLevel(userAudioLevel);
    }

    onSpeakerDetected(userId){
        this.webRTCLayer.onSpeakerDetected(userId)
    }

    onClientRegistered(channels){
        const _this = this;

        this.channel = channels[0];

        this.channel.addOnRemoteClientJoin(function (remoteClientInfo) {
            //const name = remoteClientInfo.getUserAlias() != null ? remoteClientInfo.getUserAlias() : remoteClientInfo.getUserId();

			if(_this.recorder){
				_this.recorder.addToEventLog({userId: remoteClientInfo.getUserId(), meetingUserId: remoteClientInfo.getUserAlias(), event: 'userJoined'});
			}
        });
        this.channel.addOnRemoteClientLeave(function (remoteClientInfo) {
            //const name = remoteClientInfo.getUserAlias() != null ? remoteClientInfo.getUserAlias() : remoteClientInfo.getUserId();

			if(_this.recorder){
				_this.recorder.addToEventLog({userId: remoteClientInfo.getUserId(), meetingUserId: remoteClientInfo.getUserAlias(), event: 'userLeft'});
			}
        });


        if(this.connectionMode === 'liveSwitchSfu'){
            this.channel.addOnRemoteUpstreamConnectionOpen(function (remoteConnectionInfo){
                // Is this check still needed?
                if(remoteConnectionInfo.getUserId() === _this.client.getUserId()){
                    return;
                }

                // Open downstream connection to receive the new upstream connection (reference saved when connected)
                _this.openSfuDownstreamConnection(remoteConnectionInfo);
            });
            this.channel.addOnRemoteUpstreamConnectionClose(function (remoteConnectionInfo) {
                //console.log('Remote client closed upstream connection:', remoteConnectionInfo);
            });

            if(this.communicationMode !== 'none'){
                this.openSfuUpstreamConnection('device')
            }

            // Open a downstream SFU connection for each remote upstream connection
            const remoteUpstreamConnections = this.channel.getRemoteUpstreamConnectionInfos();
            for (let i = 0; i < remoteUpstreamConnections.length; i++) {
                const remoteConnectionInfo = remoteUpstreamConnections[i];

                this.openSfuDownstreamConnection(remoteConnectionInfo);
            }
        }
        else if(this.connectionMode === 'liveSwitchPeer') {
            this.channel.addOnPeerConnectionOffer(function (peerConnectionOffer) {
                if(_this.recorder){
                    const isScreenshare = peerConnectionOffer.getConnectionTag().includes('_screen');
					if(isScreenshare){
						const remoteClientInfo = peerConnectionOffer.getRemoteClientInfo();
						_this.recorder.addToEventLog({userId: remoteClientInfo.getUserId(), meetingUserId: remoteClientInfo.getUserAlias(), event: 'screenshareStarted'});
					}
				}

                const remoteClientInfo = peerConnectionOffer.getRemoteClientInfo();
                if(remoteClientInfo.getUserId() !== _this.client.getUserId()){
                    _this.openLiveSwitchPeerAnswerConnection(peerConnectionOffer);
                }

            });

            // Opening p2p connections for each connected user
            _this.startPeer2PeerConnections('device');
        }
    }
}
